const TYPE_CHANGE_STATUS = '6';

const TYPE_MERGE = '8';
const TYPE_CONSOLIDATE = '10';

const PROGRAM_STATUS_IDS = {
    Active: 1,
    Suspended: 3,
    Eliminated: 4,
};

const getChangedValue = (details, requestLogs, fieldName) => {
    const changedPrograms = details?.changedPrograms ?? details?.ChangedPrograms ?? [];
    const changedProgramValue = changedPrograms.find(
        item => (item.changedField ?? item.ChangedField) === fieldName
    );

    if (changedProgramValue) {
        return changedProgramValue.newValue ?? changedProgramValue.NewValue;
    }

    const matchingLogs = (requestLogs ?? [])
        .filter(log => log.fieldName === fieldName || log.FieldName === fieldName)
        .sort((a, b) => {
            const aDate = new Date(a.timeStamp ?? a.TimeStamp);
            const bDate = new Date(b.timeStamp ?? b.TimeStamp);
            return aDate - bDate;
        });

    const latestLog = matchingLogs[matchingLogs.length - 1];
    return latestLog?.newFieldValue ?? latestLog?.NewFieldValue;
};

const toProgramStatusId = value => {
    if (typeof value === 'number') return value;
    if (/^\d+$/.test(value ?? '')) return Number(value);
    return PROGRAM_STATUS_IDS[value] ?? null;
};

const toTeachoutFlag = value => {
    if (typeof value === 'boolean') return value;
    if (value === null || value === undefined || value === '') return null;

    const normalized = String(value).toLowerCase();
    if (normalized === 'yes' || normalized === 'true') return true;
    if (normalized === 'no' || normalized === 'false') return false;
    return null;
};

export const getChangeStatusApprovalFields = (details, requestLogs) => {
    const requestTypeId = String(details?.typeId ?? details?.TypeId);
    if (requestTypeId === TYPE_CONSOLIDATE) {
        const sourceProgramTeachouts = details?.sourceProgramTeachouts ?? (() => {
            try {
                return JSON.parse(getChangedValue(details, requestLogs, 'Consolidating Program Teachouts') ?? '[]');
            } catch {
                return [];
            }
        })();

        return {
            ConsolidatedProgramIds:
                getChangedValue(details, requestLogs, 'Consolidated Program Ids') ??
                details?.consolidatedProgramIds ??
                (details?.sourceProgramIds ?? []).join(','),
            SourceProgramTeachouts: sourceProgramTeachouts,
        };
    }

    if (requestTypeId === TYPE_MERGE) {
        return {
            // These fields describe RequestMergeId (the absorbed source), never
            // ProgramId (the surviving destination).
            TeachoutFlag: toTeachoutFlag(
                getChangedValue(details, requestLogs, 'Teach-out Required') ??
                details?.teachoutFlag
            ),
            AllStudentsTaughtOut: toTeachoutFlag(
                getChangedValue(details, requestLogs, 'All Students Taught Out') ??
                details?.allStudentsTaughtOut
            ),
        };
    }

    if (requestTypeId !== TYPE_CHANGE_STATUS) {
        return {};
    }

    const programStatus =
        getChangedValue(details, requestLogs, 'Program Status') ?? details?.programStatus;

    return {
        ProgramStatusId: toProgramStatusId(programStatus),
        ChangeStatusAction:
            getChangedValue(details, requestLogs, 'Change Status Action') ??
            details?.changeStatusAction ??
            undefined,
        SuspensionType:
            getChangedValue(details, requestLogs, 'Suspension Type') ??
            details?.suspensionType ??
            undefined,
        TeachoutFlag: toTeachoutFlag(
            getChangedValue(details, requestLogs, 'Teach-out Required') ??
            details?.teachoutFlag
        ),
        AllStudentsTaughtOut: toTeachoutFlag(
            getChangedValue(details, requestLogs, 'All Students Taught Out') ??
            details?.allStudentsTaughtOut
        ),
    };
};
